import React, { useEffect, useRef } from "react";
import Webcam from "react-webcam";
import { isIOS, isWebView } from "../utils/deviceDetection";
import { FaCamera } from "react-icons/fa";

const CameraModal = ({ isOpen, onRequestClose, onCapture, onUpload }) => {
  const webcamRef = React.useRef(null);
  const fileInputRef = React.useRef(null);
  const shouldUseNativeCamera = isIOS() ;

  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot({
      width: 900,
      height: 900,
    });
    onCapture(imageSrc);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        onCapture(event.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const triggerNativeCamera = () => {
    fileInputRef.current.click();
  };
  
  // useEffect(() => {
  //   if (isOpen && shouldUseNativeCamera) {
  //     const timer = setTimeout(() => {
  //       triggerNativeCamera();
  //     }, 0); // slight delay to ensure modal is rendered

  //     return () => clearTimeout(timer);
  //   }
  // }, [isOpen, shouldUseNativeCamera]);

  if (!isOpen) return null;

  if (shouldUseNativeCamera) {
    return (
      <div className=" w-full bg-black rounded-lg overflow-hidden">
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          accept="image/*"
          capture="environment"
          style={{ display: 'none' }}
        />
        <div className="flex items-center justify-center h-64 bg-gray-800">
          <button
            onClick={triggerNativeCamera}
            className="w-14 h-14 rounded-full bg-white border-4 border-gray-300 flex items-center justify-center focus:outline-none"
          >
            <div className="text-red-500"><FaCamera/></div>
          </button>
        </div>
        
        <div className="p-4 bg-white">
          <div className="flex flex-col items-center gap-4">
            <p className="text-sm text-gray-600">Click the button above to open your device camera</p>
          </div>
        </div>
        
        <button 
          onClick={onRequestClose}
          className="absolute top-2 right-2 text-white p-1 rounded-full"
        >
          ✕
        </button>
      </div>
    );
  }

  return (
    <div className="relative w-full bg-black rounded-lg overflow-hidden mt-4">
      <Webcam
        audio={false}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        videoConstraints={{
          facingMode: "environment",
          width: 900,
          height: 900,
        }}
        className="w-full h-64 object-cover"
      />
      
      <div className="p-4 bg-white">
        <div className="flex flex-col items-center gap-4">
          <div className="relative">
            <button
              onClick={capture}
              className="w-14 h-14 rounded-full bg-white border-4 border-primary flex items-center justify-center focus:outline-none"
            >
              <div className="w-10 h-10 rounded-full bg-primary"></div>
            </button>
          </div>
        </div>
      </div>
      
      <button 
        onClick={onRequestClose}
        className="absolute top-2 right-2 text-white p-1 rounded-full"
      >
        ✕
      </button>
    </div>
  );
};

export default CameraModal;